export var HTTPScheme;
(function (HTTPScheme) {
    HTTPScheme[HTTPScheme["HTTP"] = 0] = "HTTP";
    HTTPScheme[HTTPScheme["HTTPS"] = 1] = "HTTPS";
})(HTTPScheme || (HTTPScheme = {}));
